import React from 'react';
import { useLocation } from 'react-router-dom';
import Navigation from './Navigation';

const AppLayout = ({ children }) => {
  const location = useLocation();
  
  // Pages where we want to show the navigation header (admin pages only)
  const showNavigationPages = [
    '/product-management',
    '/product-management-basic'
  ];
  
  // Don't show navigation on home page, admin pages, or admin login
  const shouldShowNavigation = showNavigationPages.includes(location.pathname) && 
    !location.pathname.startsWith('/39485726109384756012938475620938475610293847561029');

  return (
    <>
      {shouldShowNavigation && <Navigation />}
      {children}
    </>
  );
};

export default AppLayout; 